module.exports = __webpack_public_path__ + "img/coleccion.dba9f406.png";